// extracted by mini-css-extract-plugin
export default {"titleWrapper":"YNSp-","titleWrapperInFeed":"rbBCp","title":"w0qNh"};